export default {
  paginationContainer: {
    textAlign: 'center',
    margin: '0 auto',
  },
};



// WEBPACK FOOTER //
// ./src/components/DocumentList/styles.js